export default __webpack_public_path__ + "static/media/loader.af914b7f.gif";